module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.ttf";


// WEBPACK FOOTER //
// ../~/file-loader?publicPath=https:/cdn.printos.com/fonts/font-awesome/4.6.3/&name=[name].[ext]&emitFile=false!../~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3